interface TableSkeletonProps {
  columns?: number;
  rows?: number;
}

export function TableSkeleton({ columns = 6, rows = 5 }: Readonly<TableSkeletonProps>) {
  return (
    <output aria-label="Loading" className="border border-stroke-primary rounded-xl overflow-hidden block">
      <div className="h-[49px] bg-bg-tertiary border-b border-stroke-primary flex items-center px-4 gap-8">
        {Array.from({ length: columns }, (_, i) => (
          <div
            key={`h${i}`}
            className="h-3 rounded bg-stroke-primary animate-pulse"
            style={{ width: `${60 + i * 12}px` }}
          />
        ))}
      </div>
      {Array.from({ length: rows }, (_, i) => (
        <div
          key={`r${i}`}
          className="h-[53px] border-b border-stroke-primary last:border-b-0 flex items-center px-4 gap-8"
        >
          {Array.from({ length: columns }, (_, j) => (
            <div
              key={`c${j}`}
              className="h-3 rounded bg-bg-secondary animate-pulse"
              style={{ width: `${50 + ((i + j) % 4) * 20}px` }}
            />
          ))}
        </div>
      ))}
    </output>
  );
}
